<template>
  <div>
    <!-- begin buttons row -->
    <b-row class="m-b-15">
      <b-col>
        <input-button
          type="button"
          label="Step selection"
          class="btn-dark"
          @click="returnToSelection()"
        />
        <b-button
          v-if="!checkStepConfirmed(step)"
          class="pull-right yellow"
          :variant="'yellow'"
          @click="confirmStepPlans(step)"
        >
          Confirm all plans
        </b-button>
        <b-button
          v-else
          class="pull-right yellow"
          :variant="'outline-dark'"
          disabled
        >
          All plans confirmed
        </b-button>
      </b-col>
    </b-row>
    <!-- end buttons row -->

    <!-- Step total summary -->
    <b-row>
      <b-col>
        <b-list-group>
          <b-list-group-item class="bg-light mb-3 p-b-15">
            <span class="font-weight-bold">Step total cost:</span>
            {{ stepTotal }}
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
    <!-- end Step total summary -->

    <b-row class="m-b-15">
      <b-col>
        <script-items-list
          :categories="categories"
          :step="step"
          :type="'space'"
          :sItems="filterScriptItems(step.id, 'space')"
          :getFullItem="getFullItem"
        />
      </b-col>
    </b-row>
    <b-row class="m-b-15">
      <b-col>
        <script-items-list
          :categories="categories"
          :step="step"
          :type="'stuff'"
          :sItems="filterScriptItems(step.id, 'stuff')"
          :getFullItem="getFullItem"
        />
      </b-col>
    </b-row>
    <b-row class="m-b-15">
      <b-col>
        <script-items-list
          :categories="categories"
          :step="step"
          :type="'staff'"
          :sItems="filterScriptItems(step.id, 'staff')"
          :getFullItem="getFullItem"
        />
      </b-col>
    </b-row>
    <b-row class="m-b-15">
      <b-col>
        <script-items-list
          :categories="categories"
          :step="step"
          :type="'service'"
          :sItems="filterScriptItems(step.id, 'service')"
          :getFullItem="getFullItem"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputButton from '../buttons/InputButton.vue'
import ScriptItemsList from '../script/ScriptItemsList.vue'

export default {
  props: [
    'step',
    'scriptItems',
    'categories',
    'confirmStepPlans',
    'getFullItem',
    'returnToSelection'
  ],
  components: {
    InputButton,
    ScriptItemsList
  },
  computed: {
    stepTotal() {
      let totalCostEstimate = 0
      const currentStepScriptItems = this.scriptItems.filter((scriptItem) => {
        return this.step.id === scriptItem.step.id
      })
      currentStepScriptItems.forEach((scriptItem) => {
        if (scriptItem && !isNaN(scriptItem.costEstimate)) {
          totalCostEstimate += scriptItem.amount * scriptItem.costEstimate
        }
      })
      const formattedTotalCostEstimate = new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(totalCostEstimate)
      return formattedTotalCostEstimate
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  methods: {
    filterScriptItems(stepId, typeParam) {
      let typeId = 1
      switch (typeParam) {
        case 'service':
          typeId = 1
          break
        case 'space':
          typeId = 2
          break
        case 'staff':
          typeId = 3
          break
        case 'stuff':
          typeId = 4
          break
        default:
          typeId = 1
          break
      }
      var filteredScriptItems = this.scriptItems.filter(function (scriptItem) {
        return (
          scriptItem.step.id == stepId &&
          scriptItem.item.type == typeId &&
          scriptItem.confirmed
        )
      })
      return filteredScriptItems
    },
    checkStepConfirmed(step) {
      if (step.space && step.stuff && step.staff && step.service) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
